export const scrollToId = (id) => {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(id, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};
